import React from 'react';
import { Field } from 'redux-form';
import { translate } from 'react-admin';
import COLORS from '../theme/colors';

const CheckboxInput = ({ source, label, style, translate }) => (
  <label
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      minHeight: 36,
      margin: '10px 20px 10px 0',
      color: COLORS.text,
      fontSize: 15,
      cursor: 'pointer',
      ...style
    }}
  >
    <Field
      name={source}
      component="input"
      type="checkbox"
      style={{ width: 18, height: 18, margin: 0, cursor: 'pointer', accentColor: COLORS.primary }}
    />
    {label && <span style={{ marginLeft: 8 }}>{translate(label, { _: label })}</span>}
  </label>
);

export default translate(CheckboxInput);
